<template>
    <div class="px-2 mb-8">   
        <h5 class="text-center blue darken-4 py-2">
            <b class="white--text"> Lista de proyectos seleccionados para {{ $store.state.CARGO.sede.nombre }} </b>
        </h5> 

        <v-data-table
            :headers="headers_apb"
            :items="aprobados"
            :loading="loading" 
            dense
            disable-pagination 
            hide-default-footer
            :items-per-page="50"
            class="elevation-0 mx-8">
    
            <template v-slot:[`item.ind`]="a">
                <span> {{ a.index + 1 }} </span>
            </template> 
            <template v-slot:[`item.sede_portal_name`]="{item}">
                <span v-if="omit_sede"> {{ item.sede_portal_name }} </span>
            </template> 
            <template v-slot:[`item.fecha_registro`]="{item}">
                <span> {{ parseDateFecha(item.fecha_registro, true) }} </span>
            </template> 
            <template v-slot:[`item.fecha_aprobacion`]="{item}">
                <span> {{ parseDateFecha(item.fecha_aprobacion, true) }} </span>
            </template> 
            <template v-slot:[`item.estado_aprobacion`]="{item}">
                <v-badge v-if="item.estado_aprobacion=='PENDIENTE'" dot color="orange" />
                <v-badge v-if="item.estado_aprobacion=='APROBADO'" dot color="green" />
                <v-badge v-if="item.estado_aprobacion=='RECHAZADO'" dot color="red" />
                <span> &nbsp;{{ item.estado_aprobacion }} </span> 
            </template> 
            <template v-slot:[`item.ultima_reg_prog`]="{item}">
                <template v-if="item.ultima_reg_prog"> 
                    {{ parseDateFecha(item.ultima_reg_prog.fecha_inicio) }}
                    {{ parseDateFecha(item.ultima_reg_prog.fecha_final) }}
                </template> 
            </template> 
            <template v-slot:[`item.ultima_campania`]="{item}">
                <template v-if="item.ultima_campania">
                    <v-badge v-if="item.ultima_campania.estado=='solicitado'" dot color="orange" />
                    <v-badge v-else-if="item.ultima_campania.estado=='aprobado'" dot color="green" />
                    <v-badge v-else-if="item.ultima_campania.estado=='rechazado'" dot color="red" />
                    <v-badge v-else-if="item.ultima_campania.estado=='reprogramado'" dot color="purple" />
                    &nbsp;
                    {{ parseDateFecha(item.ultima_campania.fecha_inicio) }}
                    {{ parseDateFecha(item.ultima_campania.fecha_final) }}
                </template> 
            </template> 
            <template v-slot:[`item.opt`]="{item}">
                <div>
                    <v-menu offset-x offset-y v-if="item.estado_aprobacion=='APROBADO'">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="my-0 py-0" color="primary" outlined small dark v-bind="attrs" v-on="on">
                                <v-icon>mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="background-color: #162455;">
                            <v-list-item style="background: #19670d;" dark class="ma-1" v-if="!isestado(item,'aprobado')" link @click="crearcampania(item)">
                                <v-list-item-title>
                                    <v-icon small>mdi-flag</v-icon>
                                    Crear campaña
                                </v-list-item-title>
                            </v-list-item>  
                            <v-list-item style="background: #9d5a1a;" dark class="ma-1" v-if="isestado(item,'aprobado')" link @click="reprogramacampania(item)">
                                <v-list-item-title>
                                    <v-icon small>mdi-cog-refresh</v-icon>
                                    Reprogramar campaña
                                </v-list-item-title>
                            </v-list-item>  
                            <v-list-item style="background: #1a729d;" dark class="ma-1" v-if="isestado(item,'aprobado')" link @click="crearPrograma(item)">
                                <v-list-item-title>
                                    <v-icon small>mdi-folder-plus</v-icon>
                                    Crear programa
                                </v-list-item-title>
                            </v-list-item>  
                        </v-list>
                    </v-menu>  
                    <v-btn v-if="item.estado_aprobacion=='RECHAZADO'" color="red" small tile dense outlined @click="vermotivo(item)">
                        <v-icon>mdi-eye</v-icon>
                    </v-btn>
                </div>
            </template>

        </v-data-table>   
        <!-- <seleccionarModal ref="refSeleccionarModal" v-on:onsuccess="getDatos" /> -->
        <solicitar_campania ref="refsolicitar_campania" v-on:onsuccess="getDatos" />
        <vermotivo ref="refvermotivo" />
    </div>
</template>
  
<script>
import solicitar_campania from './solicitar_campania.vue';
// import seleccionarModal from './seleccionar-modal.vue';
import { parseDateFecha} from '../util.ts'
import { seleccionados_dbs } from '@/views/oferta_academica/servicios/seleccionService.ts';
import { getPosgrado } from '../autoria/utils.ts';
import { solicitar_fecha_campania,reprogramar_fecha_campania } from '../servicios/seleccionService.ts';
import vermotivo from './ver-motivo'

export default {
    components: {solicitar_campania,vermotivo}, 
    data() {
        return {
            loading: false,
            headers_apb: [ 
                { text: '#', value: 'ind' },
                { text: 'proyecto', value: 'nombre_proyecto', width:'350' },
                // { text: 'proyecto id', value: 'proyecto_id' }, 
                { text: '', value: 'sede_portal_name' }, 
                { text: 'proyecto de', value: 'sede_name' }, 
                { text: 'fecha solicitud', value: 'fecha_registro' }, 
                { text: 'fecha aprob', value: 'fecha_aprobacion' }, 
                { text: 'estado', value: 'estado_aprobacion', width:'130' },
                { text: 'reg prog portal', value: 'ultima_reg_prog', width:'130' },
                { text: 'campania', value: 'ultima_campania', width:'130' },
                { text: '', value: 'opt' },
            ],  
            aprobados: [], 
            parseDateFecha,   
            omit_sede: true,
            unidad_id: null,
        };
    },
    watch: {
        '$store.state.CARGO': function( ){  
            this.getDatos();
        }, 
    },
    methods: {
        async getDatos(omit_sede =false){ 
            this.aprobados = []; 
            this.omit_sede = omit_sede;
            const q = {
                sede_portal_id:this.$store.state.CARGO.sede.id,
                unidad_negocio_id:this.$store.state.CARGO.sede.unidad_negocio,
            }
            if(omit_sede) delete q.sede_portal_id;

            this.loading = true;
            const r = await seleccionados_dbs(q)
            if(r && r.seleccionados_dbs){
                this.aprobados = r.seleccionados_dbs 
            } 
            this.loading = false;
            this.unidad_id = this.$store.state.CARGO.sede.unidad_negocio
        },  
        isestado(item, est){
            if(!item.ultima_campania) return false
            return item.ultima_campania.estado == est
        },

        async crearcampania(proysel){
            const r = await this.$refs.refsolicitar_campania.openmodal(proysel);
            if(!r) return; 

            const da = {
                programa_seleccionado_id: proysel.id,
                proyecto_id: proysel.proyecto_id,
                fecha_inicio: r.fecha_inicio, 
                fecha_inicio_reg_prog: r.fecha_inicio_prog, 
                fecha_limite_reg_prog: r.fecha_limite_prog, 
                solicitado_por_id: this.$store.state.DATA_USER.id
            }
            this.loading = true;
            const res = await solicitar_fecha_campania(da);
            window.console.log('res', res.graphQLErrors);
            this.loading = false;
            if(res && res.solicitar_fecha_campania){
                this.getDatos();
            }else if(res && res.graphQLErrors) {
                let m = ''
                res.graphQLErrors.forEach(x => (m += x.message));  
                this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }else{
              const m = JSON.stringify(res);
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }

        },

        async reprogramacampania(proysel){
            const rol = this.$store.state.CARGO.id;
            const p = rol == 1 || rol == 11 || rol == 12 
            if(!p){
                this.$root.$notify.show(`rol de usuario no permitido para reprogramar`, {color:'red',x: 'right',});
                return;
            } 

            const r = await this.$refs.refsolicitar_campania.openmodal(proysel);
            if(!r) return; 

            const da = {
                programa_seleccionado_id: proysel.id,
                proyecto_id: proysel.proyecto_id,
                fecha_inicio: r.fecha_inicio, 
                fecha_inicio_reg_prog: r.fecha_inicio_prog, 
                fecha_limite_reg_prog: r.fecha_limite_prog, 
                solicitado_por_id: this.$store.state.DATA_USER.id
            }
            this.loading = true;
            const res = await reprogramar_fecha_campania(da);
            window.console.log('res', res.graphQLErrors);
            this.loading = false;
            if(res && res.reprogramar_fecha_campania){
                this.getDatos();
            }else if(res && res.graphQLErrors) {
                let m = ''
                res.graphQLErrors.forEach(x => (m += x.message));  
                this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }else{
              const m = JSON.stringify(res);
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }

        },
 
        async crearPrograma(proy){ 
            window.console.log('ultima_reg_prog',proy.ultima_reg_prog);
            const rol = this.$store.state.CARGO.id;
            const p = rol == 1 || rol == 5 || rol == 6 || rol == 23 
            if(!p){
                this.$root.$notify.show(`esta funcion es para academicos`, {color:'red',x: 'right',});
                return;
            } 

            if( this.unidad_id == 1) {
                this.crearProgramaEsam(proy)
                return;
            }
            
            if(!proy.ultima_campania) {
                this.$root.$notify.show('no hay fecha de campaña', {color:'red',x: 'right',timeout:800});
                return;
            }
            if(!proy.ultima_reg_prog) {
                this.$root.$notify.show('no hay fecha de registro en portal', {color:'red',x: 'right',timeout:800});
                return;
            }else{
                const inicio = new Date(proy.ultima_reg_prog.fecha_inicio);
                const final = new Date(proy.ultima_reg_prog.fecha_final);
                const ahora = new Date(); 
                final.setHours(23);
                final.setMinutes(59); 
                final.setSeconds(59);
                
                const estaDentro = ahora >= inicio && ahora <= final;
                window.console.log('estaDentro:::',estaDentro);
                if(!estaDentro){
                    const s = 'estas fuera del periodo de registro de programas en el portal ESAM';
                    this.$root.$notify.show(s, {color:'red',x: 'right',timeout:2500});
                    return;
                }
                
            }
            // let a = 1;
            // if(a > 0) return;
        
            const est = proy.ultima_campania.estado;
            if(est != 'aprobado' && est != 'reprogramado') {
                this.$root.$notify.show('la fecha de campaña debe ser aprobada', {color:'red',x: 'right',timeout:1500});
                return;
            }

            const ispermitido = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 5 || this.$store.state.CARGO.id == 6;
            if(!ispermitido){
                this.$root.$notify.show('no tiene autorizacion.', {color:'red',x: 'right',timeout:1800});
                return;
            }
            const item = await getPosgrado(this,proy.postgrado_id)
            
            this.$store.dispatch('postgrado/selectPostgrado', item);
            window.sessionStorage.setItem('xpostgradorest', JSON.stringify(item));
            this.$router.push({ name: 'programaviewrest' });
        }, 
        async crearProgramaEsam(proy){
            const item = await getPosgrado(this,proy.postgrado_id)
            
            this.$store.dispatch('postgrado/selectPostgrado', item);
            window.sessionStorage.setItem('xpostgradorest', JSON.stringify(item));
            this.$router.push({ name: 'programaviewrest' });
        },
        vermotivo(item){
            this.$refs.refvermotivo.openmodal(item);
        },
    },
    mounted() {   
        this.unidad_id = this.$store.state.CARGO.sede.unidad_negocio
        if(this.unidad_id == 1){ 
            // estas fechas no les interesa a ESAM
            this.headers_apb = this.headers_apb.filter(x=>x.value != 'ultima_reg_prog')
        }
        this.getDatos();  
    },
};
</script>
  